import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../../app/i18n";
import { DriveModePage } from "../../../areas/seller/drive/DriveScreen";
import { stopDriveMode } from "../../../areas/seller/drive/driveSession";

/**
 * FE-10 drive mode (FR-FE10-01). The route plugin code-splits the component; the `map` namespace
 * supplies the FE-06 website-type labels of the announcement card. Leaving the route stops GPS,
 * speech and the wake lock (FR-FE01-09).
 */
export const Route = createFileRoute("/app/_seller/drive")({
  beforeLoad: () => loadNamespaces("map"),
  component: DriveModePage,
  onLeave: stopDriveMode,
});
